import { render, staticRenderFns } from "./file-block.vue?vue&type=template&id=e51a72e2&"
import script from "./file-block.vue?vue&type=script&lang=js&"
export * from "./file-block.vue?vue&type=script&lang=js&"
import style0 from "./file-block.vue?vue&type=style&index=0&id=e51a72e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports